import React from 'react'
import {Alert, AlertTitle} from '@material-ui/lab'

const UnrecognizedError = () => (
    <Alert severity="error">
        <AlertTitle>Error. </AlertTitle>
        Something went wrong.
    </Alert>
);

export default UnrecognizedError;
